"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushPullModule = void 0;
const tslib_1 = require("tslib");
const AdaptableModuleBase_1 = require("@adaptabletools/adaptable/src/Strategy/AdaptableModuleBase");
const ModuleConstants = tslib_1.__importStar(require("@adaptabletools/adaptable/src/Utilities/Constants/ModuleConstants"));
const throttle_1 = tslib_1.__importDefault(require("lodash/throttle"));
const GeneralConstants_1 = require("@adaptabletools/adaptable/src/Utilities/Constants/GeneralConstants");
const EQUAL_DATA_ERR = 'equal data, so not sending';
class PushPullModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.IPushPullModuleId, 'ipushpull', 'download', null, 'Send data from AdapTable to ipushpull', api);
        this.isSendingData = false;
        this.ippService = null;
        this.adaptable = api.internalApi.getAdaptableInstance();
        this.api.eventApi.on('AdaptableReady', () => {
            setTimeout(() => {
                this.throttledRecomputeAndSendLiveDataEvent = (0, throttle_1.default)(() => this.sendNewLiveData(), this.getThrottleTimeFromState());
            }, 1000);
        });
        // if a piece of data has updated then update any live reports except cell or row selected where the data change is relevant
        // currently we DONT send deltas - we simply send everything to ipushpull every time a relevant change happens
        this.api.internalApi
            .getDataService()
            .on('CellDataChanged', (cellDataChangedInfo) => {
            const api = this.getIPPApi();
            const exportApi = this.api.exportApi;
            if (api.isIPushPullLiveDataRunning()) {
                let currentLiveIPushPullReport = api.getCurrentLiveIPushPullReport();
                if (currentLiveIPushPullReport &&
                    currentLiveIPushPullReport.ReportName !== GeneralConstants_1.SELECTED_CELLS_REPORT &&
                    currentLiveIPushPullReport.ReportName !== GeneralConstants_1.SELECTED_ROWS_REPORT &&
                    exportApi.internalApi.isDataChangeInReport(cellDataChangedInfo, this.getCurrentReport())) {
                    this.throttledRecomputeAndSendLiveDataEvent();
                }
            }
        });
        // if the grid has refreshed then update all live reports
        this.adaptable._on('GridRefreshed', () => {
            if (this.getIPPApi().isIPushPullLiveDataRunning()) {
                this.throttledRecomputeAndSendLiveDataEvent();
            }
        });
        // if the grid filters have changed then update any live reports except cell or row selected
        this.adaptable._on('AdapTableFiltersApplied', () => {
            // Rerun all reports except selected cells / rows when filter changes
            if (this.getIPPApi().isIPushPullLiveDataRunning()) {
                let currentLiveIPushPullReport = this.getIPPApi().getCurrentLiveIPushPullReport();
                if (currentLiveIPushPullReport &&
                    currentLiveIPushPullReport.ReportName !== GeneralConstants_1.SELECTED_CELLS_REPORT &&
                    currentLiveIPushPullReport.ReportName !== GeneralConstants_1.SELECTED_ROWS_REPORT) {
                    this.throttledRecomputeAndSendLiveDataEvent();
                }
            }
        });
        // if grid selection has changed and the ipushpull Live report is 'Selected Cells' or 'Selected Rows' then send updated data
        this.api.eventApi.on('CellSelectionChanged', () => {
            if (this.getIPPApi().isIPushPullLiveDataRunning()) {
                let currentLiveIPushPullReport = this.getIPPApi().getCurrentLiveIPushPullReport();
                if (currentLiveIPushPullReport &&
                    currentLiveIPushPullReport.ReportName === GeneralConstants_1.SELECTED_CELLS_REPORT) {
                    this.throttledRecomputeAndSendLiveDataEvent();
                }
            }
        });
        this.api.eventApi.on('RowSelectionChanged', () => {
            if (this.getIPPApi().isIPushPullLiveDataRunning()) {
                let currentLiveIPushPullReport = this.getIPPApi().getCurrentLiveIPushPullReport();
                if (currentLiveIPushPullReport &&
                    currentLiveIPushPullReport.ReportName === GeneralConstants_1.SELECTED_ROWS_REPORT) {
                    this.throttledRecomputeAndSendLiveDataEvent();
                }
            }
        });
    }
    getViewAccessLevel() {
        return 'Full';
    }
    setModuleEntitlement() {
        // TODO
        if (!this.api.pluginsApi.getipushpullPluginApi().isIPushPullAvailable()) {
            this.AccessLevel = 'Hidden';
        }
        else {
            this.AccessLevel = this.api.internalApi
                .getEntitlementService()
                .getEntitlementAccessLevelForModule(this.moduleInfo.ModuleName);
        }
    }
    getIPPApi() {
        return this.api.pluginsApi.getipushpullPluginApi();
    }
    getCurrentReport() {
        const api = this.getIPPApi();
        const exportApi = this.api.exportApi;
        if (api.isIPushPullLiveDataRunning()) {
            let currentLiveIPushPullReport = api.getCurrentLiveIPushPullReport();
            return currentLiveIPushPullReport
                ? exportApi.getReportByName(currentLiveIPushPullReport.ReportName)
                : null;
        }
        return null;
    }
    getIPPService() {
        if (!this.ippService) {
            this.ippService = this.adaptable.getPluginProperty('ipushpull', 'service') || null;
        }
        return this.ippService;
    }
    sendNewLiveData() {
        //we wait for the last sendNewLiveData to finish
        if (this.isSendingData == true) {
            this.throttledRecomputeAndSendLiveDataEvent();
            return;
        }
        let currentLiveIPushPullReport = this.getIPPApi().getCurrentLiveIPushPullReport();
        if (currentLiveIPushPullReport) {
            this.isSendingData = true;
            let report = this.api.exportApi.getReportByName(currentLiveIPushPullReport.ReportName);
            let reportAsArray = this.adaptable.ReportService.getReportDataAsArray(report);
            const currentData = JSON.stringify(reportAsArray);
            if (currentData === this.lastData) {
                this.adaptable.logger.warn(EQUAL_DATA_ERR);
                this.isSendingData = false;
                return;
            }
            Promise.resolve()
                .then(() => {
                return new Promise((resolve, reject) => {
                    if (reportAsArray) {
                        resolve(reportAsArray);
                    }
                    else {
                        reject('no data in the report');
                    }
                });
            })
                .then((reportAsArray) => {
                return this.getIPPService().pushData(currentLiveIPushPullReport.Page, reportAsArray);
            })
                .then(() => {
                this.lastData = currentData;
                return this.adaptable.ReportService.PublishLiveLiveDataChangedEvent('ipushpull', 'LiveDataUpdated', currentLiveIPushPullReport);
            })
                .catch((reason) => {
                this.adaptable.logger.warn('Failed to send data to ipushpull for [' + currentLiveIPushPullReport.ReportName + ']', reason);
                this.stopLiveData();
                let errorMessage = 'Export Failed';
                if (reason) {
                    errorMessage += ': ' + reason;
                }
                errorMessage += '.  This live export has been cancelled.';
                this.api.alertApi.showAlertError('ipushpull Export Error', errorMessage);
            });
            Promise.resolve()
                .then(() => {
                this.adaptable.logger.success('All live report data sent');
                this.isSendingData = false;
            })
                .catch(() => {
                this.adaptable.logger.warn('Failed to send data');
                this.isSendingData = false;
            });
        }
    }
    sendSnapshot(iPushPullReport) {
        this.getIPPService()
            .loadPage(iPushPullReport.Folder, iPushPullReport.Page)
            .then(() => {
            let report = this.api.exportApi.getReportByName(iPushPullReport.ReportName);
            if (report) {
                let reportAsArray = this.adaptable.ReportService.getReportDataAsArray(report);
                if (reportAsArray) {
                    this.getIPPService().pushData(iPushPullReport.Page, reportAsArray);
                }
            }
        });
    }
    startLiveData(iPushPullReport) {
        this.getIPPService()
            .loadPage(iPushPullReport.Folder, iPushPullReport.Page)
            .then(() => {
            this.getIPPApi().startLiveData(iPushPullReport);
        });
    }
    stopLiveData() {
        this.lastData = '';
        this.getIPPApi().stopLiveData();
    }
    getThrottleTimeFromState() {
        let iPushPullThrottleTime;
        if (this.getIPPApi().isIPushPullRunning()) {
            iPushPullThrottleTime = this.getIPPApi().getIPushPullThrottleTime();
        }
        return iPushPullThrottleTime ? iPushPullThrottleTime : GeneralConstants_1.DEFAULT_LIVE_REPORT_THROTTLE_TIME;
    }
}
exports.PushPullModule = PushPullModule;
